import './App.css';

function CallLineItem({ call, searchText }) {
  const highlightText = (text) => {
    if (!searchText) return text;
    const regex = new RegExp(`(${searchText})`, 'gi');
    return text.replace(regex, '<mark style="background-color: yellow">$1</mark>');
  };

  return (
    <div className="max-w-6xl mx-auto">
      <article className="bg-white rounded-none border-t border-gray-200 my-4 sm:my-6 p-4 sm:p-6 first:border-t-0">
        <header className="flex items-start justify-between mb-3 sm:mb-4">
          <div className="flex-1">
            <h2 className="text-lg sm:text-xl font-semibold text-black mb-1 sm:mb-2">
              <a 
                href={call.external ? call.external_url : call.path}
                className="hover:text-gray-600 transition-colors duration-200 flex items-center gap-2"
              >
                <img 
                  className="w-3 h-3 sm:w-4 sm:h-4 grayscale"
                  src={`https://www.google.com/s2/favicons?domain=${new URL(call.external_url).hostname}`}
                  alt={new URL(call.external_url).hostname}
                />
                <span dangerouslySetInnerHTML={{ __html: highlightText(call.name) }} />
              </a>
            </h2>
            <p className="text-xs sm:text-sm text-gray-600">
              Deadline: <time>{call.entry_deadline}</time>
            </p>
          </div>
        </header>

        {call.description && (
          <div className="prose prose-xs sm:prose-sm max-w-none text-gray-700 mb-3 sm:mb-4 text-sm sm:text-base">
            <div dangerouslySetInnerHTML={{ 
              __html: highlightText(call.expanded_description)
            }} />
          </div>
        )}

        {window.location.hostname === 'localhost' && (
          <div className="mb-4">
            <a 
              href={`http://localhost:3001/api/v1/development/scrape_call/${call.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-blue-600 hover:text-blue-800"
            >
              Scrape Call
            </a>
          </div>
        )}

        <footer className="flex items-center justify-between pt-3 sm:pt-4">
          <div className="flex-1">
            {call.entry_fee !== null && (
              <div className="text-xs sm:text-sm font-medium text-gray-700">
                {call.entry_fee === 0 ? (
                  <span className="inline-flex items-center px-2 sm:px-3 py-0.5 sm:py-1 rounded-full text-xs sm:text-sm font-medium bg-green-100 text-green-800">
                    🎉 FREE Entry!
                  </span>
                ) : (
                  `Entry fee: $${Math.round(call.entry_fee / 100)}`
                )}
              </div>
            )}
          </div>
          
          <a 
            href={call.external ? call.external_url : call.path}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center rounded-lg px-3 sm:px-4 py-1.5 sm:py-2 border border-black text-xs sm:text-sm font-medium text-white bg-black hover:bg-white hover:text-black transition-colors duration-200"
          >
            Apply Now
          </a>
        </footer>
      </article>
    </div>
  );
}

export default CallLineItem;
